import './search-box-filter-style.scss'

import { useUserRegionCH } from '@cdc-internal/mkt-nav-footer'
import { Field, Form, Formik } from 'formik'
import _ from 'lodash'
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'

import { getTransWithoutMissingKey } from '@/i18n/config'
import { useUKAccess } from '@/modules/useUKAccess'

import { orderFilterItems } from '../filters/filter-order'

const SearchBoxFilter = forwardRef(
  (
    { options, onChange, type, title, selectedSortBy, isMobile, isReset },
    ref
  ) => {
    const isUKIp = useUKAccess()
    const userRegion = useUserRegionCH()
    const { t, i18n } = useTranslation()
    const [opt, setOptions] = useState([])
    const formikRef = useRef(null)
    useImperativeHandle(ref, () => ({
      resetForm: () => {
        if (formikRef.current) {
          formikRef.current.resetForm()
        }
      },
    }))

    const classNameCategory = (option) => {
      if (option && option.value) {
        switch (true) {
          case option.value.startsWith('intermediate'):
            return 'university intermediate'
          case option.value.startsWith('advanced'):
            return 'university advanced'
          case option.value.startsWith('beginner'):
            return 'university beginner'
          default:
            break
        }
      }
    }

    useEffect(() => {
      const getSubCategory = () => {
        let cat
        if (options && options.length) {
          if (type === 'category' || type === 'sortBy') {
            cat = options
          } else {
            const result = _.head(_.filter(options, (ct) => ct.value === type))
            cat = _.get(result, 'children', [])
          }
        }
        return cat
      }
      let data = getSubCategory()
      data = orderFilterItems(type, data, isUKIp, userRegion)
      setOptions(data)
    }, [options, type, isUKIp, userRegion])

    useEffect(() => {
      if (isMobile && isReset) {
        formikRef.current.resetForm()
      }
      // else if (isMobile) {
      //   return null
      // }
    }, [selectedSortBy, isReset, isMobile])

    useEffect(() => {
      formikRef.current.setValues({ value: selectedSortBy })
    }, [selectedSortBy])

    return (
      <div>
        <h4 className="search-aside-title-filter">{title}</h4>
        <Formik innerRef={formikRef} initialValues={{ value: selectedSortBy }}>
          {(props) => {
            const onChangeValues = (option) => {
              props.setFieldValue('value', option.value)
              onChange(option.value)
            }

            return (
              <Form>
                <div
                  role="group"
                  aria-labelledby="checkbox-group"
                  className="checkbox-group"
                >
                  {_.map(opt, (option) => (
                    <label
                      className={classNameCategory(option)}
                      key={option.value}
                    >
                      <Field
                        type={'radio'}
                        name={'picked'}
                        value={getTransWithoutMissingKey(
                          `categories.${option.slug}`,
                          i18n,
                          t
                        )}
                        onChange={() => onChangeValues(option)}
                        checked={props.values.value === option.value}
                      />
                      <span>
                        {i18n.exists(option.label)
                          ? t(option.label)
                          : option.label}
                      </span>
                    </label>
                  ))}
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }
)

SearchBoxFilter.displayName = 'SearchBoxFilter'
export default SearchBoxFilter
